import api from './api';

const attendanceCorrectionService = {
  /**
   * Create attendance correction request (HR only)
   */
  createCorrectionRequest: async (requestData) => {
    const response = await api.post('/attendance/corrections/request', requestData);
    return response.data;
  },

  /**
   * Get HR's correction requests
   */
  getHRCorrectionRequests: async (status = null) => {
    const params = status ? `?status=${status}` : '';
    const response = await api.get(`/attendance/corrections/my-requests${params}`);
    return response.data;
  },

  /**
   * Get pending correction requests for HRO
   */
  getPendingRequests: async () => {
    const response = await api.get('/attendance/corrections/pending');
    return response.data;
  },

  /**
   * Get all correction requests for HRO (optional status filter)
   */
  getHROCorrectionRequests: async (status = '') => {
    const query = status ? `?status=${encodeURIComponent(status)}` : '';
    const response = await api.get(`/attendance/corrections/requests${query}`);
    return response.data;
  },

  /**
   * Get correction request details
   */
  getCorrectionRequestDetails: async (id) => {
    const response = await api.get(`/attendance/corrections/${id}`);
    return response.data;
  },

  /**
   * Review correction request (HRO only)
   */
  reviewCorrectionRequest: async (id, action, comments = '') => {
    const response = await api.put(`/attendance/corrections/${id}/review`, {
      action,
      comments
    });
    return response.data;
  }
};

export default attendanceCorrectionService;